export enum MeasurementSystemActions {
  UPDATE_MEASUREMENT_SYSTEM_ACTION = "UPDATE_MEASUREMENT_SYSTEM_ACTION",
}